import script from "./ContratoVendaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ContratoVendaForm.vue?vue&type=script&setup=true&lang=js"

import "./ContratoVendaForm.vue?vue&type=style&index=0&id=4edd66e7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4edd66e7"]])

export default __exports__